import React from "react";
import { Input } from "../ui/input";

import global from "../../scss/dhp.scss";
import { COMPANY_SUPERADMIN } from "../../constants/company";
import { useCheckCompanyPlanInfo } from "../../hooks/useCheckCompanyPlanInfo";
import useAccessControl from "../../hooks/useAccessControl";
let style = Object.assign({}, global);

const TaxInputDropdown = ({
  options,
  defaultValue,
  updateState,
  disabled = false,
  dropdownContainer = undefined,
  customDropdownMenuClass,
  showManageOption = true,
  ...props
}) => {
  const paidCompanyInfo = useCheckCompanyPlanInfo(true);
  const isSuperAdmin = paidCompanyInfo?.companyRole === COMPANY_SUPERADMIN;

  const { checkAccess } = useAccessControl();
  let hasManageProposalAccess = checkAccess("Manage_Proposal_Settings");
  const TooltipText = isSuperAdmin || hasManageProposalAccess ? "Manage Tax" : "Only Admin can manage Tax";

  return (
    <Input
      cssModule={style}
      returnType="formGroup"
      formGroupClass={style["w-100"]}
      type="multi_select"
      noOptionMessage="No results found"
      options={options ?? []}
      defaultValue={defaultValue}
      optionValue={"name"}
      optionTextPrimary={["name"]}
      updateState={updateState}
      disabled={disabled}
      dropdownContainer={dropdownContainer}
      customDropdownMenuClass={customDropdownMenuClass}
      {...props}
      {...(showManageOption && {
        manageItemLink: `/companies/settings/taxes`,
        isSuperAdmin: isSuperAdmin || hasManageProposalAccess,
        manageItemText: TooltipText,
        isCloseHide: true,
      })}
    />
  );
};

export default TaxInputDropdown;
